import { ChangeDetectionStrategy, Component, input, OnInit, output } from '@angular/core';
import {
  IFullFranchiseItem,
  IHome_Franchises_Localization,
  IHome_FranchisesResponse,
} from '@shared/constants/models.const';
import { FranchiseIconComponent } from '@shared/components/franchise-icon/franchise-icon.component';
import { ClickOutside } from '@shared/directives/click-outside';
import { TranslateModule } from '@ngx-translate/core';

export interface IFranchiseItem {
  country: string;
  route: string;
  language: string;
  franchiseLocalization: string;
}

@Component({
  selector: 'app-franchise-input',
  imports: [
    FranchiseIconComponent,
    ClickOutside,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './franchise-input.component.html',
  styleUrl: './franchise-input.component.scss',
})
export class FranchiseInputComponent implements OnInit {
  title = input<string>('Franchise');
  franchises = input<IHome_FranchisesResponse[]>();
  preselectedFranchise = input<string>();
  frChange = output<IFranchiseItem>();
  isDropdownOpen = false;
  selectedFranchise!: IFranchiseItem;
  defaultValue: IFranchiseItem = {
    country: 'Global',
    language: 'English',
    route: 'en',
    franchiseLocalization: 'GlobalEnglish',
  };

  get value(): string {
    return this.selectedFranchise ? `${this.selectedFranchise.country} (${this.selectedFranchise.language})` : 'Select franchise';
  }

  ngOnInit(): void {
    if (!this.preselectedFranchise()) {
      this.selectedFranchise = this.defaultValue;
      this.frChange.emit(this.selectedFranchise);

    } else {
      this.setPreselectedFranchise();
    }
  }

  setPreselectedFranchise(): void {
    this.franchises()?.map(fr => {
      fr.localizations.forEach((localization) => {
        if (localization?.route === this.preselectedFranchise()) {
          this.selectedFranchise = {
            country: fr.country,
            route: localization.route,
            language: localization.language,
            franchiseLocalization: localization.franchiseLocalization,
          };
        }
      });
    });
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  clickOutside() {
    this.isDropdownOpen = false;
  }

  getFrTitle(frArr?: IHome_FranchisesResponse, frItem?: IFullFranchiseItem): string {
    const reqFrItem = (frArr && frItem) ? { ...frItem, country: frArr.country } : this.selectedFranchise;
    return `${reqFrItem.country} (${reqFrItem.language})`;
  }

  selectFr(item: IHome_FranchisesResponse, frItem: IHome_Franchises_Localization): void {
    this.selectedFranchise = {
      country: item.country,
      route: frItem.route,
      language: frItem.language,
      franchiseLocalization: frItem.franchiseLocalization,
    };
    this.isDropdownOpen = false;
    this.frChange.emit(this.selectedFranchise);
  }
}
